import type { SerializableNode } from '@/serializer';

import type { DreamRenderElementProps } from '../../types';
import type { BadgeType } from '../shared/types';

export type TAccountProfileAttributes = {
  id?: string;
  data: {
    firstName?: string;
    lastName?: string;
    avatarUrl?: string;
    email: string;
    emailChangeStatusBadge?: {
      type: BadgeType;
      text: string;
    };
  };
};

export type TAccountProfileElement = {
  type: 'accountProfile';
  attrs?: TAccountProfileAttributes;
  content?: SerializableNode[];
};

export enum SocialLoginProviderType {
  DISCORD = 'discord',
  SPOTIFY = 'spotify',
}

interface SocialLoginProviderMap {
  [SocialLoginProviderType.DISCORD]: {
    name: string;
  };
  [SocialLoginProviderType.SPOTIFY]: {
    name: string;
  };
}

interface BaseSocialLogin {
  id: string;
}

export type SocialLoginProvider = {
  [K in SocialLoginProviderType]: BaseSocialLogin & {
    provider: K;
  } & SocialLoginProviderMap[K];
}[SocialLoginProviderType];

type BaseAccountProfileElementProps = {
  isLive?: boolean;
  canResetPassword: boolean;
  isLoading: boolean;
} & DreamRenderElementProps<TAccountProfileElement>;

export type AccountProfileElementProps =
  | (BaseAccountProfileElementProps & {
      showActions: false;
    })
  | (BaseAccountProfileElementProps & {
      showActions: true;
      socialLoginProviders: SocialLoginProvider[];
      onClickConnections: () => void;
      onClickEditProfile: () => void;
      onClickResetPassword: () => void;
      onClickLogout: () => void;
    });
